import { useRef, useState } from 'react';

// A modal Radix popover sets `pointer-events: none` on <body> while it is open, so the
// click that closes it lands on <html> and never reaches what the user clicked: the
// click is swallowed. Popovers only need to be modal inside a dialog (so their list
// scrolls and takes focus above the dialog's own scroll lock), so be modal only there.
export const useModalInsideDialog = <T extends HTMLElement = HTMLButtonElement>() => {
  const triggerRef = useRef<T>(null);
  const [modal, setModal] = useState(false);

  // Call before opening, so the popover opens with the right mode.
  const noteOpenChange = (open: boolean) => {
    if (open) {
      setModal(!!triggerRef.current?.closest('[role="dialog"], [role="alertdialog"]'));
    }
  };

  return { triggerRef, modal, noteOpenChange };
};
